//https://swiperjs.com/
import Swiper from 'swiper';
import {Navigation, Pagination, EffectFade, A11y, Keyboard, FreeMode, Autoplay} from 'swiper/modules';

//import swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/a11y';

const heroSlideshow = document.querySelector('.js-hero-slideshow');

if( heroSlideshow ){
    //MAIN HERO SLIDESHOW
    const mainSwiper = new Swiper(heroSlideshow, {
        modules: [EffectFade,Pagination,Navigation,A11y,Keyboard,Autoplay],
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: false,
        autoplay: {
            delay: 6000,
            disableOnInteraction: true,
        },
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        navigation: {
            addIcons: false,
            nextEl: heroSlideshow.querySelector('.swiper-button-next'),
            prevEl: heroSlideshow.querySelector('.swiper-button-prev')
        },
        pagination: {
            el: heroSlideshow.querySelector('.swiper-pagination'),
            type: 'bullets',
            hideOnclick: false,
            clickable: false
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });
}

const serviceSlideshows = document.querySelectorAll('.js-service-slideshow');
serviceSlideshows.forEach((slideshow, index) => {

    let serviceSlider = slideshow;
    let prev = slideshow.querySelector('.swiper-button-prev');
    let next = slideshow.querySelector('.swiper-button-next');

    const mainSwiper = new Swiper(serviceSlider, {
        modules: [EffectFade,Pagination,Navigation,A11y,Keyboard],
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: false,
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        navigation: {
            addIcons: false,
            nextEl: next,
            prevEl: prev
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

});

const gallerySlideshows = document.querySelectorAll('.js-gallery-slideshow');
gallerySlideshows.forEach((slideshow, index) => {

    let gallerySlider = slideshow;
    let prev = slideshow.querySelector('.swiper-button-prev');
    let next = slideshow.querySelector('.swiper-button-next');

    const mainSwiper = new Swiper(gallerySlider, {
        modules: [EffectFade,Pagination,Navigation,A11y,Keyboard],
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: false,
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        navigation: {
            addIcons: false,
            nextEl: next,
            prevEl: prev
        },
        pagination: {
            el: gallerySlider.querySelector('.swiper-pagination'),
            type: 'bullets',
            hideOnclick: false,
            clickable: false
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

});

const timelineSlideshows = document.querySelectorAll('.timeline-slideshow-wrapper');
timelineSlideshows.forEach((slideshow, index) => {

    let timelineSlider = slideshow.querySelector('.timeline-slideshow');
    let prev = slideshow.querySelector('.swiper-button-prev');
    let next = slideshow.querySelector('.swiper-button-next');

    const mainSwiper = new Swiper(timelineSlider, {
        modules: [Navigation,A11y,Keyboard,FreeMode],
        effect: 'slide',
        loop: false,
        slidesPerView: 'auto',
        snapToSlideEdge: true,
        freeMode: true,
        a11y: {
            enabled: true,
            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
        },
        navigation: {
            addIcons: false,
            nextEl: next,
            prevEl: prev
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

});